import React, {Component} from 'react';
import OrderTableCell from './OrderTableCell';
import {urlPrefix, get} from 'engine/dataServices';
import jMoment from "moment-jalaali";


let counter = 0;

function createData(orderId, name, image, orderDate, deliveryDate, status) {
    counter += 1;
    return {id: counter, orderId, name, image, orderDate, deliveryDate, status};
}

class LatestOrders extends Component {
    constructor(props) {
        super(props);

        jMoment.loadPersian({dialect: 'persian-modern'});

        this.state = {
            data: [
                /*createData("23545", "Alex Dolgove", 'http://via.placeholder.com/256x256', "25 Oct", "25 Oct", 'Completed'),
                createData("23653", "Domnic Brown", 'http://via.placeholder.com/256x256', "28 Oct", "1 Nov", 'On Hold'),
                createData("24567", "Garry Sobars", 'http://via.placeholder.com/256x256', "5 Nov", "10 Nov", 'Delayed'),
                createData("25745", "Stella Johnson", 'http://via.placeholder.com/256x256', "23 Nov", "26 Nov", 'Cancelled'),
                createData("24567", "Garry Sobars", 'http://via.placeholder.com/256x256', "5 Nov", "10 Nov", 'Delayed'),*/
            ],
        }
    }

    componentWillMount() {
        this.loadData();
    }

    async loadData() {
        const res = await get('Order/Last5Orders');
        const _data = [];

        if (res.status == 200) {
            const responseData = await res.json();

            responseData.map(x => {
                counter += 1;

                let image = x.User.Setting.UserImage;
                image = (image) ? urlPrefix + image : require('assets/Images/TolitonAvatar.png');

                _data.push({
                    id: counter,
                    orderId: x.Id,
                    username: x.User.Mobile,
                    image: image,
                    createDate: jMoment(x.CreatedDate).format('jYYYY/jMM/jDD'),
                    modifiedDate: jMoment(x.ModifiedDate).format('jYYYY/jMM/jDD'),
                    step: x.Step,
                    stepTitle: x.StepTitle
                })
            });

            this.setState({data: _data});
        }
    }

    render() {
        const {data} = this.state;
        return (
            <div className="jr-card">
                <div className="jr-card-header d-flex align-items-center">
                    <h3 className="d-inline-block mb-0">سفارشات اخیر</h3>
                    <span className="text-white badge badge-success">5 سفارش آخر</span>
                </div>
                <div className="table-responsive-material">
                    <table className="default-table table-unbordered table table-sm table-hover">
                        <thead className="th-border-b">
                        <tr>
                            <th className='text-center'>شناسه سفارش</th>
                            <th className='text-center' colSpan="2">کاربر</th>
                            <th className='text-center'>تاریخ ثبت</th>
                            <th className='text-center'>آخرین ویرایش</th>
                            <th className="status-cell text-center">وضعیت</th>
                        </tr>
                        </thead>
                        <tbody>
                        {data.map(data => {
                            return (
                                <OrderTableCell key={data.id} data={data}/>
                            );
                        })}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default LatestOrders;


// WEBPACK FOOTER //
// ./components/toliton/desktop/latestOrders/latestOrders.js